import { RefObject, MutableRefObject } from 'react';
import mapboxgl from 'mapbox-gl';
import { useMapLoadingState } from './hooks/useMapLoadingState';
import { useMapLifecycle } from './hooks/useMapLifecycle';

interface MapInitializationResult {
  isLoading: boolean;
  error: Error | null;
}

export const useMapInitialization = (
  mapContainer: RefObject<HTMLDivElement>,
  mapRef: MutableRefObject<mapboxgl.Map | null>,
  defaultCenter: [number, number],
  isVisible: boolean
): MapInitializationResult => {
  const { isLoading, setIsLoading, error, setError } = useMapLoadingState();
  
  useMapLifecycle(mapContainer, mapRef, defaultCenter, setIsLoading, setError, isVisible);

  return { isLoading, error };
};